import React from 'react'
import logo from "../../images/logo.png"

const Header = ({ resources, title, language, onLanguageChange, containerClass }) => {
    return (
        <>
            <div className="container-fluid px-0 header-top-bar" style={{ backgroundColor: "#feca0a" }}>
                <div className="header-top-inner">
                    <img src={logo} alt="Logo" className="img-fluid header-logo" />
                    <div className="language-switch">
                        <button
                            className={`lang-btn${language === 'de' ? ' active' : ''}`}
                            onClick={() => onLanguageChange('de')}
                        >de</button>
                        <span className="lang-divider">|</span>
                        <button
                            className={`lang-btn${language === 'fr' ? ' active' : ''}`}
                            onClick={() => onLanguageChange('fr')}
                        >fr</button>
                    </div>
                </div>
            </div>

            <div className="header-title-box">
                <div className="container page-container p-0">
                    <div className={containerClass}>
                    <span>{title}</span>
                </div>
                </div>
            </div>
        </>
    )
}

export default Header